
import { Vue, Component, Prop } from 'vue-property-decorator'

import { ConfigState, Erg } from 'shared/state'

import Color from './Color.vue'
import Multiselect from './Multiselect.vue'

@Component({ components: { Color, Multiselect }})
export default class DisplayClasses extends Vue {

	@Prop() config!: ConfigState

	get classOptions() {
		return Erg.classes
	}
	get displayClasses() {
		return this.config.vals.raceConfig.displayClasses
	}
	get classColors() {
		return this.config.vals.raceTheme.classColors
	}

	updateClassColor(i: number, color: string) {
		const newClassColors = this.classColors.slice()
		newClassColors[i] = color
		this.config.set({ raceTheme: { classColors: newClassColors } })
	}

	updateDisplayClasses(classes: string[]) {
		this.config.set({ raceConfig: { displayClasses: classes }})
	}

}
